import gql from "graphql-tag";

export const citiesQuery = gql`
  query cities(
    $search: String
    $countryId: ID
  ) {
    cities(name_Icontains: $search, country: $countryId, first: 10){
      edges {
        node {
          id
          name
          region {
            id
            name
          }
        }
      }
    }
  }
`;